import request from '@/utils/request';
import ENDPOINT from '@/config/endpoint';

// Lấy URL đăng nhập Google
function getLinkLogin(params) {
  return request({
    url: `${ENDPOINT.OAUTH2}/login`,
    method: 'GET',
    params,
  });
}

// Đăng ký bằng Google
function register(data, token) {
  return request({
    url: `${ENDPOINT.OAUTH2}/register`,
    method: 'POST',
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

// Gọi thông tin tài khoản Google
function getInfoGoogleAccount(token, data) {
  return request({
    url: `${ENDPOINT.OAUTH2}/info`,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data,
  });
}

export default {
  getLinkLogin,
  register,
  getInfoGoogleAccount,
};
